module.exports = __webpack_public_path__ + "static/media/bdb-entreview-ico-blue-2.96fe0787.svg";